import React, { useState } from 'react';
import SideActionBoard from '../../../../../../components/SideActionBoard';

import Exercise from './Exercise';

const Sidebar = ({ openSideActionBoard, setOpenSideActionBoard }) => {
  const { action, ids } = openSideActionBoard;

  return (
    <SideActionBoard setOpenSideActionBoard={setOpenSideActionBoard}>
      <Exercise
        id={ids[0]}
        type={action}
        openSideActionBoard={openSideActionBoard}
        setOpenSideActionBoard={setOpenSideActionBoard}
      />
      )
    </SideActionBoard>
  );
};

export default Sidebar;
